/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Váš účet byl úspěšně vytvořen!`
};

const da_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Din konto er oprettet!`
};

const de_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Konto wurde erfolgreich erstellt!`
};

const en_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Your account has been successfully created !`
};

const es_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `¡Tu cuenta ha sido creada correctamente!`
};

const fr_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Votre compte a bien été crée !`
};

const hu_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `A fiókodat sikeresen létrehoztuk!`
};

const it_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo account è stato creato!`
};

const nl_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Je account is succesvol aangemaakt!`
};

const pl_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Twoje konto zostało utworzone!`
};

const pt_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Sua conta foi criada com sucesso!`
};

const sv_account_created = /** @type {(inputs: {}) => string} */ () => {
	return `Ditt konto har skapats!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_created = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_created(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_created", locale)
	if (locale === "cs") return cs_account_created(inputs)
	if (locale === "da") return da_account_created(inputs)
	if (locale === "de") return de_account_created(inputs)
	if (locale === "en") return en_account_created(inputs)
	if (locale === "es") return es_account_created(inputs)
	if (locale === "fr") return fr_account_created(inputs)
	if (locale === "hu") return hu_account_created(inputs)
	if (locale === "it") return it_account_created(inputs)
	if (locale === "nl") return nl_account_created(inputs)
	if (locale === "pl") return pl_account_created(inputs)
	if (locale === "pt") return pt_account_created(inputs)
	return sv_account_created(inputs)
};
export { account_created as "account.created" }